import { createEnv } from '@t3-oss/env-core';
import { z } from 'zod';

export const env = createEnv({
  clientPrefix: 'VITE_',
  client: {
    VITE_BASE_URL: z.string().min(1),
    VITE_BUILD_OUTPUT_DIR: z.string().min(1),
    VITE_SHIPLEX_BASE_URL: z.string().optional(),
    VITE_SHIPLEX_LEGACY_APP_ROUTE: z.string().min(1),
    VITE_MOCK_MODE: z.string().optional()
  },
  runtimeEnv: {
    VITE_BASE_URL: import.meta.env.VITE_BASE_URL,
    VITE_BUILD_OUTPUT_DIR: import.meta.env.VITE_BUILD_OUTPUT_DIR,
    VITE_SHIPLEX_BASE_URL: import.meta.env.VITE_SHIPLEX_BASE_URL,
    VITE_SHIPLEX_LEGACY_APP_ROUTE: import.meta.env.VITE_SHIPLEX_LEGACY_APP_ROUTE,
    VITE_MOCK_MODE: import.meta.env.VITE_MOCK_MODE
  }
});
